import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { PurchaseOrderCreditNoteStatusDto } from './purchaseOrderCreditNoteStatus.dto';
import { PurchaseOrderItemDto } from './purchaseOrderItem.dto';
import { PurchaseOrderStatusDto } from './purchaseOrderStatus.dto';
import { SupplierDto } from './supplier.dto';
import { UserDto } from './user.dto';

export class PurchaseOrderDto extends BaseDto {
    purchaseOrderStatusId: number;
    purchaseOrderNumber: number;
    orderDate?: string;
    deliveryDate?: string;
    receivedDate?: string;
    delayDate?: string;
    createdByUserId?: number;
    placedByUserId: number;
    authorisedByUserId: number;
    amendedByUserId: number;
    receivedByUserId: number;
    refusedByUserId: number;
    supplierId: number;
    merchantId: number;
    merchantGroupId: number;
    note?: string;
    lines?: number;
    itemTotal?: number;
    gross?: number;
    vat?: number;
    net?:number;
    drsValue?: number;
    surchargeValue?: number;
    purchaseOrderStatus: PurchaseOrderStatusDto;
    purchaseOrderCreditNoteStatus?:PurchaseOrderCreditNoteStatusDto;
    createdByUser: UserDto;
    placedByUser: UserDto;
    amendedByUser: UserDto;
    authorisedbyUser: UserDto;
    receivedByUser: UserDto;
    refusedByUser: UserDto;
    supplier: SupplierDto;
    merchant: MerchantDto;
    merchantSupplier?: MerchantDto;
    merchantGroup: MerchantGroupDto;
    purchaseOrderItem: PurchaseOrderItemDto[];
    orderedItems?: number;
    receivedItems?: number;
    missingItems?: number;
    isTransfer?: boolean;
    fromLocation?: string;
    transfer?: boolean;
    isAdHoc?: boolean;
    merchantSupplierId?: number;
    deliveryDocketNumber?: string;
    deliveryDockImage?: string;
    typeCode?: string;
    deliveryCost?: number;
    user?:string;
    dateProcessed?:string;
    authorisationEmail?: string;

    purchaseOrderCreditNoteStatusId: number;
    purchaseOrderId: number;
    requestedByUserId:number;
    purchaseOrder?: PurchaseOrderDto;
    closedByUserId: number;
    //Credit Note Type
    // Needed to change because the change on the UP-7442
    _type: string;
    orderPO?: string;
    requestedByUser: UserDto;
    closedByUser: UserDto;
    // emergencyDeliveryCost is when the supplier has emergency delivery enabled, to take in consideration on the final cost
    emergencyDeliveryCost: number;
    fromMerchants?: MerchantDto[];
    fromBrands?: BrandDto[];

    // if we continue adding new fields to the purchaseorderItem I will delete this fuction for clarity and add it one one by the values
    constructor(
        merchantId: number,
        merchantGroupId: number,
        supplier: SupplierDto,
        deliveryDate: string,
        createdByUser: UserDto,
        placedByUser?: UserDto,
        purchaseOrderId=null,
        type=null,
        isAdHoc=false,
        isTransfer=false,
    ) {
        super();
        const now=new Date();
        this.purchaseOrderStatusId = this.purchaseOrderCreditNoteStatusId = 1;
        this.merchantId = merchantId;
        this.merchantGroupId = merchantGroupId;
        this.supplier = supplier;
        this.orderDate = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0");
        this.deliveryDate = deliveryDate;
        this.createdByUserId = createdByUser?.id;
        if (placedByUser) {
            this.placedByUser = placedByUser;
        }
        this.isAdHoc = isAdHoc;
        this.isTransfer = isTransfer;
        this._type = type;
        this.purchaseOrderId = purchaseOrderId;
        this.typeCode = 'PI';
    }
}